import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PreviewStore {

}

export enum PreviewStoreKeys {

}
